import $ from 'jquery';

const mobileNav = {
		
	init: function() {
		this.pancake = $('[data-js-header="pancake"]');
		this.header = $('[data-js-header="header"]');
		
		this.eventHandlers();
	},
	
	eventHandlers: function() {
		this.pancake.on('click',this.toggleNav.bind(this));
	},
	
	toggleNav: function() {
		this.header.toggleClass('is-open');
		this.pancake.toggleClass('is-active');
	}
}

$(document).ready(()=>{
	mobileNav.init();
})